import { Form, Row, Col, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { DropdownOption } from '@app/models/DropdownOption';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';

type Field = {
  key: string;
  label: string;
  type: 'text' | 'number' | 'dropdown' | 'richtext';
  options?: DropdownOption[];
};

type AdditionalInfoProps = {
  editable: boolean;
  fields?: Field[];
  additionalInfo?: Record<string, any>;
};

const AdditionalInfo: React.FC<AdditionalInfoProps> = ({ editable, fields = [], additionalInfo = {} }) => {
  const [formValues, setFormValues] = useState<Record<string, any>>({});
  const [resolvedFields, setResolvedFields] = useState<Field[]>([]);

  useEffect(() => {
    if (fields && fields.length > 0) {
      setResolvedFields(fields);
    }
  }, [fields]);

  useEffect(() => {
    if (additionalInfo && typeof additionalInfo === 'object') {
      setFormValues(additionalInfo);
    }
  }, [additionalInfo]);

  return (
    <>
      {resolvedFields.length > 0 ? (
        <Row gutter={[16, 16]}>
          {resolvedFields.map((field) => (
            <Col key={field.key} span={12}>
              <Form.Item name={field.key} label={field.label} initialValue={formValues[field.key] || ''}>
                {editable ? (
                  field.type === 'dropdown' ? (
                    <Select options={field.options} defaultValue={formValues[field.key] || undefined} />
                  ) : (
                    <BaseInput type={field.type} defaultValue={formValues[field.key] || ''} />
                  )
                ) : (
                  <span>
                    {field.type === 'dropdown'
                      ? field.options?.find((opt) => opt.value === formValues[field.key])?.label || ' '
                      : formValues[field.key] || ' '}
                  </span>
                )}
              </Form.Item>
            </Col>
          ))}
        </Row>
      ) : (
        <p>No additional fields available.</p>
      )}
    </>
  );
};
export default AdditionalInfo;
